export const NODES_BASE_KEY = ['nodes'] as const
